import HeroSection from "./components/HeroSection";
import TrustBar from "../../components/feature/TrustBar";
import ServicesOverview from "./components/ServicesOverview";
import MidPageCTA from "../../components/feature/MidPageCTA";
import AIAnswerBlock from "../../components/feature/AIAnswerBlock";
import ProcessSection from "../../components/feature/ProcessSection";
import WhyChooseUs from "./components/WhyChooseUs";
import ServiceAreasSection from "../../components/feature/ServiceAreasSection";
import TestimonialsSection from "../../components/feature/TestimonialsSection";
import FAQSection from "../../components/feature/FAQSection";
import FinalCTASection from "../../components/feature/FinalCTASection";

export default function HomePage() {
  return (
    <main>
      {/* 1. Hero */}
      <HeroSection />
      {/* 2. Trust Bar */}
      <TrustBar />
      {/* 3. Services Overview */}
      <ServicesOverview />
      {/* Mid-Page CTA — conversion block after services */}
      <MidPageCTA />
      {/* 4. AI Answer Block */}
      <AIAnswerBlock />
      {/* 5. Process */}
      <ProcessSection />
      {/* 6. Why Choose Us */}
      <WhyChooseUs />
      {/* 7. Service Areas */}
      <ServiceAreasSection />
      {/* 8. Testimonials */}
      <TestimonialsSection />
      {/* 9. FAQ */}
      <FAQSection />
      {/* 10. Final CTA */}
      <FinalCTASection />
    </main>
  );
}
